import gtmService from '../utils/gtmService'

export default defineNuxtPlugin(() => {
  window.didomiOnReady = window.didomiOnReady || []
  window.didomiOnReady.push(() => {
    gtmService.init()
  })
})
